import {DestroyRef, inject, Injectable} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {concatMap} from 'rxjs';
import {EVENT_BUS} from 'src/app/shared/domain/tokens/event-bus.token';
import {WaiterSignOutEvent} from 'src/app/shared/application/events/waiter/waiter-sign-out.event';
import {SignOutWaiterUseCase} from '../use-cases/sign-out.usecase';

/**
 * Sign Out Waiter Subscriber
 * Listens to WaiterSignOutEvent and executes the sign out process.
 *
 * This subscriber follows the same pattern as other domain subscribers in the system
 * and handles the reactive execution of waiter sign out operations when the corresponding
 * event is published to the event bus.
 */
@Injectable()
export class SignOutWaiterSubscriber {
  private readonly eventBus = inject(EVENT_BUS);
  private readonly signOutWaiterUseCase = inject(SignOutWaiterUseCase);
  private readonly destroyRef = inject(DestroyRef);

  constructor() {
    this.eventBus.ofType(WaiterSignOutEvent).pipe(
      concatMap(() => this.signOutWaiterUseCase.execute()),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe();
  }
}
